"use client";
import React from 'react'
import Reveal from "./Reveal";
import {
  GraduationCap,
  Factory,
  Clock3,
  UserRoundCheck,
} from "lucide-react";


const About = () => {
  const features = [
    {
      icon: Factory,
      title: "Industry-Aligned Research",
      desc: "Research shaped around live industry challenges and applied innovation needs.",
    },
    {
      icon: Clock3,
      title: "Flexible Pathways",
      desc: "Full-time and part-time options for scholars and working professionals.",
    },
    {
      icon: GraduationCap,
      title: "Skill-Based Doctorate",
      desc: "Build both academic depth and professional research capability.",
    },
    {
      icon: UserRoundCheck,
      title: "Expert Supervision",
      desc: "Guidance from experienced academic and industry-exposed supervisors.",
    },
  ];
  return (
    <section id="about" className="py-14 md:py-20 bg-white">
      <div className="max-w-(--max-page-width) px-(--container-padding) mx-auto ">
        <div className="grid lg:grid-cols-2 gap-0 md:gap-14 items-center">
          <Reveal>
            <div className="relative">
              <img
                src="https://cdn.msu.edu.in/msu-reavamp/phd/why-choose-msu.webp"
                alt="PhD research"
                className="rounded-2xl w-full h-90 object-cover shadow-xl hidden md:block"
              />
              <div className="absolute -bottom-6 -right-6 bg-[#0475B3] text-white rounded-2xl p-5 shadow-xl w-48 hidden md:block">
                <div className="text-3xl font-black text-[#FFA201]">2026</div>
                <div className="text-sm font-bold mt-1">Admissions Open</div>
                <div className="text-blue-200 text-sm mt-0.5">Apply before seats fill</div>
              </div>
              <div className="absolute -top-5 -left-5 bg-[#FFA201] text-[#081E2D] rounded-2xl p-4 shadow-xl hidden md:block">
                <div className="text-2xl font-black">UGC</div>
                <div className="text-sm font-bold">Recognised</div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={150}>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-0.5 bg-[#FFA201]" />
              <span className="text-[#0475B3] text-xs font-black uppercase tracking-widest">About the Ph.D. Programme</span>
            </div>
            <h2 className="text-4xl font-black text-[#081E2D] mb-5 leading-tight">
              Research that Moves<br />the World Forward
            </h2>
            <p className="text-gray-600 mb-4 leading-normal text-md">
              At Medhavi Skills University, the Ph.D. Programme is designed for real-world impact. It focuses on applied, interdisciplinary
              and industry-aligned research that addresses workforce gaps, policy challenges and innovation needs.
            </p>
            <p className="text-gray-500 text-md mb-8 leading-relaxed">
              Scholars move beyond theory to create solutions that contribute to industry, governance and society.
            </p>
            <h2 className="text-xl font-black text-[#081E2D] mb-5 leading-tight">
              Why Choose MSU for Ph.D.?
            </h2>

            <div className="grid  md:grid-cols-2 gap-4">
              {features.map((item, index) => {
                const Icon = item.icon;

                return (
                  <div key={index} className="flex items-start gap-4">
                    <div className="p-3 rounded-xl bg-[#EBF5FB]">
                      <Icon size={28} className="text-[#0475B3]" />
                    </div>

                    <div>
                      <h3 className="font-bold text-[#081E2D]">{item.title}</h3>
                      <p className="text-gray-600 text-sm">{item.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export default About